import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import CheckBoxLabel from "components/CheckBoxLabel";

import { IResultCheckBox } from "../../../../components/CheckBoxGlobal";
import { useToast } from "../../../../hooks/toast";
import { hearingFileTypeAttendantRole } from "../../../../services/hearingFileTypeAttendantRole";
import { LogOperation } from "../../../../utils/entities/logOperation";
import {
  Container,
  ContainerBody,
  ContainerInputs,
} from "../../StyleCSS/bodyCreateEdit";
import { IDefaultObject, IHearingFileTypeAttendantRoleItem } from "../index";
import { ContentCheckbox } from "../styles";

interface ICreateEditHearingFileTypeAttendantRole {
  isEdit: boolean;
  postOrPutTrue: boolean;
  setPostOrPutTrue: (e: boolean) => unknown;
  hearingFileTypeList: Array<IDefaultObject>;
  attendantRoleList: Array<IDefaultObject>;
  hearingFileTypeAttendantRoleItem?: IHearingFileTypeAttendantRoleItem;
  closeModal: boolean;
  hearingFileTypeId: any;
  setCloseModal: (e: boolean) => unknown;
}

export const CreateEditHearingFileTypeAttendantRole = (
  props: ICreateEditHearingFileTypeAttendantRole,
): JSX.Element => {
  const { t } = useTranslation();
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const { addToast } = useToast();

  const [listToShow, setListToShow] = useState<IResultCheckBox[]>([]);
  const [newListChecks, setNewListChecks] = useState<IResultCheckBox[]>([]);

  const relationshipOriginalList =
    props.hearingFileTypeAttendantRoleItem?.attendantRoleList ?? [];
  let listIdsToDelete: number[] = [];
  let listIdsToAdd: number[] = [];

  useEffect(() => {
    setIsLoad(true);
    if (props.isEdit) {
      setListToShow(
        convertTypeList(
          props.hearingFileTypeAttendantRoleItem?.attendantRoleList ?? [],
          false,
        ),
      );
    }
    setIsLoad(false);
  }, []);

  useEffect(() => {
    if (props.postOrPutTrue) {
      putUpdate();
      props.setPostOrPutTrue(false);
    }
  }, [props.postOrPutTrue]);

  useEffect(() => {
    props.setCloseModal(true);
  }, [props.closeModal]);

  function validationFields() {
    if (listIdsToDelete.length === 0 && listIdsToAdd.length === 0) {
      addToast({
        type: "warning",
        title: t("administration.hearingFileTypeAttendantRoles.linkTitle"),
        description: t("audiences.hearingTypeLink.updateRequired"),
      });
      return false;
    }
    return true;
  }

  async function putUpdate() {
    try {
      choiseAction();
      if (!validationFields()) return;
      for (const id of listIdsToAdd) {
        await hearingFileTypeAttendantRole.vincularHearingFileTypeEAttendantRole(
          LogOperation.getCustomerId(),
          props.hearingFileTypeId,
          id,
        );
      }
      for (const id of listIdsToDelete) {
        await hearingFileTypeAttendantRole.deletarVinculoHearingFileTypeEAttendantRole(
          id,
        );
      }
      addToast({
        type: "success",
        title: t("administration.hearingFileTypeAttendantRoles.linkTitle"),
        description: t("audiences.hearingTypeLink.updateSuccess"),
      });
      listIdsToDelete = [];
      listIdsToAdd = [];
      props.setCloseModal(false);
    } catch {
      addToast({
        type: "warning",
        title: t("administration.hearingFileTypeAttendantRoles.linkTitle"),
        description: t("audiences.hearingTypeLink.createRequired"),
      });
    }
  }

  function convertTypeList(
    arrayAttendant: IDefaultObject[],
    disabled: boolean,
  ): IResultCheckBox[] {
    return props.attendantRoleList.map((item) => ({
      id: item.attendantRoleId,
      label: item.name,
      isChecked: arrayAttendant.some((x) => x.id === item.attendantRoleId),
      disabled:
        disabled && arrayAttendant.some((x) => x.id === item.attendantRoleId),
    }));
  }

  function choiseAction() {
    for (const element of newListChecks) {
      const existedBefore = relationshipOriginalList.some(
        (x) => x.id === element.id,
      );
      if (element.isChecked && !existedBefore) {
        listIdsToAdd.push(element.id);
      }
      if (!element.isChecked && existedBefore) {
        const toDelete = relationshipOriginalList.find(
          (x) => x.id === element.id,
        );
        if (toDelete?.hearingFileTypeAttendantRoleId) {
          listIdsToDelete.push(toDelete.hearingFileTypeAttendantRoleId);
        }
      }
    }
  }

  function handleToggle(id: number) {
    const updated = listToShow.map((item) =>
      item.id === id ? { ...item, isChecked: !item.isChecked } : item,
    );
    setListToShow(updated);
    setNewListChecks(updated);
  }

  return (
    <>
      {!isLoad && (
        <Container>
          <ContainerBody>
            <ContainerInputs>
              <h2>
                {props.hearingFileTypeAttendantRoleItem?.hearingFileTypeName}
              </h2>
            </ContainerInputs>

            <ContentCheckbox>
              {listToShow.map((item) => (
                <CheckBoxLabel
                  key={item.id}
                  id={`checkbox-${item.id}`}
                  label={item.label}
                  checked={item.isChecked}
                  disabled={item.disabled}
                  onChange={() => handleToggle(item.id)}
                />
              ))}
            </ContentCheckbox>
          </ContainerBody>
        </Container>
      )}
    </>
  );
};
